import { render, staticRenderFns } from "./MakeDeposit.vue?vue&type=template&id=e2c1edc6&"
import script from "./MakeDeposit.vue?vue&type=script&lang=js&"
export * from "./MakeDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports